<template>
		<section class="ftco-section">
		<div class="container">
             <div v-if="error">
                <app-message :matn="error_message" ></app-message>
            </div>
			<div class="row justify-content-center">
				<div class="col-md-7 col-lg-4">
					<div class="login-wrap p-4 p-md-5">
		      	<div class="icon d-flex align-items-center justify-content-center">
		      		<span class="fa fa-key"></span>
		      	</div>

		      	<h3 class="text-center mb-4">Сброс пароля</h3>
                <div >
                <v-form @submit.prevent="forget"
                 v-if="!sms_success"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                 <v-alert
                elevation="4"
                color=#1976D2
                outlined
                shaped
                type="info"
                >
                Введите ниже номер телефон, который вы указали при регистрации. Мы отправим пин-код по сбросу пароля
                </v-alert>
                    <v-text-field
                    v-model="form.login"
                    :counter="9"
                    :rules="nameRules"
                    label="Номер телефона"
                    clearable
                    required
                    autofocus
                    ></v-text-field>



	            <div class="form-group mt-4" v-if="!loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                   type="submit"
                    >Отправить</v-btn>

	            </div>
                 <div class="form-group mt-4" v-if="loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                    ><loading-spin></loading-spin></v-btn>

	            </div>

                     </v-form>

                     <div v-if="sms_success">
                    <div class="ma-auto position-relative" style="max-width: 300px">
                    <v-otp-input
                        v-model="otp"
                        :disabled="loading"
                        @finish="onFinish"
                        type="number"
                    ></v-otp-input>
                    <v-overlay absolute :value="loading">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                    </v-overlay>
                    </div>
                    <div class="text--caption">Введите 6-значный код.</div>

                </div>

                </div>

	            <div class="form-group d-md-flex">
	            	<div class="w-50">
                <router-link to="/auth" >Авторизация</router-link>
								</div>

	                </div>

	                </div>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
import axios from 'axios'
  export default {
    data: () => ({
      valid: false,
      form: {
        login: '',
      },
      sms_success: false,
      loading: false,
      error: false,
      error_message: '',

       snackbar: false,
      snackbarColor: 'default',
      otp: '',
      expectedOtp: '291133',

      nameRules: [
        v => !!v || 'Введите номер телефона',
        v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
        v => (v && v.length == 9) || 'Неверный формат номера телефона',
      ],


    }),

    methods: {


      forget(){

        axios.post('/api/forget', this.form, {
                headers: {
                    "Content-type": "application/json"
                }
            })

                .then(response => {
                    if(response.data.status){
                        this.$session.start();
                       // this.$router.push({name: 'home'});
                       this.loading = false;
                        this.error = true;
                        this.error_message = response.data.message;
                        this.sms_success = true;
                        this.$session.set('kod', response.data.kod);
                        this.expectedOtp = response.data.kod;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }else{
                        this.loading  = false;
                        this.error = true;
                        this.error_message = "Ошибка операции";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading  = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });
      },

            onFinish (rsp) {
            this.loading = true
            setTimeout(() => {
            this.loading = false
            if(this.otp == this.expectedOtp){

                this.error = true;
                this.error_message = "success";
                this.$router.push({name: 'home'});
            }else{
                this.error = true;
                this.error_message = "Неверный пин-код";
                 setTimeout(() => {
                    this.error = false;
                    this.otp = '';
                }, 2000);

            }
            }, 3500)
      },
      }

    }

</script>

<style>
 .position-relative {
   position: relative;
 }
</style>
